import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { Color } from "../../theme/Color";

type CardTitleProps = {
  title: string;
  centered?: boolean;
  icon: IconDefinition;
};

const StyledRow = styled(Row)`
  padding: 0.75rem 0.5rem 0.75rem 0.5rem;
  border-bottom: 1px solid ${Color.BlackShadow1};
  margin-bottom: 2rem;
`;

const StyledCardTitle = styled.h3`
  font-weight: bold;
`;

const CardTitle = ({
  title,
  centered = false,
  icon = null,
}: CardTitleProps) => {
  return (
    <StyledRow middle="xs">
      <Col xs={icon ? 10 : 12}>
        {centered && (
          <Row center="xs">
            <StyledCardTitle>{title}</StyledCardTitle>
          </Row>
        )}
        {!centered && <StyledCardTitle>{title}</StyledCardTitle>}
      </Col>
      {icon && (
        <Col xs={2}>
          <Row end="xs">
            <FontAwesomeIcon
              icon={icon}
              style={{ color: Color.Grey2 }}
              size="2x"
            />
          </Row>
        </Col>
      )}
    </StyledRow>
  );
};

export default CardTitle;
